import type { ReactNode } from 'react';
import { useT } from '../../i18n';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export interface AppShellProps {
  children: ReactNode;
  onOpenSearch?: () => void;
}

/** Desktop-first two-column shell: fixed sidebar, scrollable work area. */
export const AppShell = ({ children, onOpenSearch }: AppShellProps) => {
  const { t } = useT();

  return (
  <div className="flex h-full min-h-full">
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded-md focus:bg-surface focus:px-3 focus:py-2"
    >
      {t('common.skipToContent')}
    </a>
    <Sidebar />
    <div className="flex min-w-0 flex-1 flex-col">
      <Topbar {...(onOpenSearch ? { onOpenSearch } : {})} />
      {/* `relative`: visually hidden elements (`.sr-only`) are absolutely
          positioned, and without a positioned ancestor their static position
          deep inside this scroll container stretches the document itself —
          which showed up as empty space below a long form. */}
      <main id="main" className="relative min-w-0 flex-1 overflow-y-auto">
        <div className="page-container flex flex-col gap-4 py-5">
          {children}
        </div>
      </main>
    </div>
  </div>
  );
};
